<template>
  <div class="app has-fullwidth">
    <the-header></the-header>
    <main class="app-main" ref="app">
      <div class="wrapper">
        <loading :active.sync="callingAPI" :can-cancel="false" :is-full-page="fullPage" loader="bars" color="#346cb0" :width="40"></loading>
        <router-view></router-view>
      </div>
    </main>
    <the-footer></the-footer>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import TheHeader from './Header'
import TheFooter from './Footer'
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import AxiosCall from "../../../libs/AxiosCall";
import {urlApi} from "../../../config/url-api";
export default {
  name: "Home",
  components: {
    TheHeader,
    TheFooter,
    Loading
  },
  data(){
    return {
      fullPage: true
    }
  },
  computed:{
    ...mapGetters(['callingAPI'])
  },
  methods:{
    removeLS(){
      localStorage.removeItem("user-token")
      localStorage.removeItem("user-profile")
    },
    successMessage(title){
      this.$bvToast.toast(title, {
        title: `Success`,
        variant: 'success',
        solid: true
      })
    },
    errorMessage(title){
      this.$bvToast.toast(title, {
        title: `Error`,
        variant: 'danger',
        solid: true
      })
    },
    companySettings(){
      AxiosCall.Get({}, urlApi.company.setting_transaction).then(resp=>{
        if(resp.success){
          this.$store.commit("COMPANY_SETTINGS", resp.atributes)
          localStorage.setItem('company-settings', JSON.stringify(resp.atributes))
        }
      })
    }
  },
  created() {
    this.companySettings()
    // window.addEventListener('beforeunload', this.removeLS)
  },
}
</script>